const RISK_OF_MAINTAINABILITY_MAP = [
  "all",
  "undefined",
  "low",
  "medium",
  "high",
];

export default RISK_OF_MAINTAINABILITY_MAP;
